import React from 'react';
import Stepper from '../rentals/Stepper';
import Step from '../rentals/Step';
import StepConnector from '../rentals/StepConnector';
import { ThreeDots, ArrowUp, Settings, CheckMarkEmpty } from 'Utils/SvgIcons';

class ImportWizardProgress extends React.Component {
  // The Dream Import Wizard (TD1-10584) adds a Translate step between Upload and Adjust; the plain wizard is unchanged.
  getProgressionIndex = (status, dream) => {
    const steps = dream
      ? ['selectType', 'upload', 'translate', 'adjust', 'preview', 'done']
      : ['selectType', 'upload', 'adjust', 'preview', 'done'];
    return steps.indexOf(status);
  };

  render() {
    const { importStatus, uploading, dream } = this.props;
    const activeStep = this.getProgressionIndex(importStatus, dream);
    const adjustConnector = uploading ? (
      <StepConnector complete={false} dottedConnector={true} />
    ) : (
      <StepConnector />
    );
    // Stepper reads every child's props, so the optional Translate step is spliced in, never rendered as false.
    const steps = [
      <Step
        key='selectType'
        label='Select Type'
        icon={<ThreeDots viewBox='0 0 12 4' />}
      />,
      <Step
        key='upload'
        label='Upload'
        icon={<ArrowUp />}
        connector={<StepConnector />}
      />,
      <Step
        key='adjust'
        label='Adjust'
        icon={<Settings />}
        connector={dream ? <StepConnector /> : adjustConnector}
      />,
      <Step
        key='preview'
        label='Preview'
        icon={<CheckMarkEmpty />}
        connector={<StepConnector />}
      />,
      <Step
        key='done'
        label='Done!'
        icon={<CheckMarkEmpty />}
        connector={<StepConnector />}
      />,
    ];
    if (dream) {
      steps.splice(
        2,
        0,
        <Step
          key='translate'
          label='Translate'
          icon={<Settings />}
          connector={adjustConnector}
        />
      );
    }

    return (
      <Stepper activeStep={activeStep} inactiveStep={dream ? 6 : 5}>
        {steps}
      </Stepper>
    );
  }
}

export default ImportWizardProgress;
